
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/selling/simple-sales-process",
      function () {
        return require("private-next-pages/content/selling/simple-sales-process.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/selling/simple-sales-process"])
      });
    }
  